import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { fillAuthAction } from './actions/user';
import Loadable from 'react-loadable';
import LoadingScreen from './components/shared/LoadingScreen';

const LazyLogin= Loadable({
  loader: () => import('./components/Login'),
  loading: LoadingScreen,
});


const LazyPublic= Loadable({
  loader: () => import('./components/public'),
  loading: LoadingScreen,
});

const LazyAdminDashboard = Loadable({
  loader: () => import('./components/admin'),
  loading: LoadingScreen,
});

const LazyCaptainDashboard = Loadable({
  loader: () => import('./components/captain'),
  loading: LoadingScreen,
});

const PrivateRoute = ({ component: Component, isAuth, ...rest }) => (
  <Route {...rest} render={(props) => (
    isAuth
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

class App extends Component {
  componentDidMount(){
    let token = sessionStorage.getItem("auth-token"),
        username = sessionStorage.getItem("auth-username"),
        role = sessionStorage.getItem("auth-role");
    if(token && username && role) this.props.dispatch(fillAuthAction(token, username, role));
  }
  render() {
    return (
      <div className="wrapper">
        <Router>
          <Switch>
            <Route path="/" component={LazyPublic} exact/>
            { this.props.user.role === 'centerManager' ? 
              <PrivateRoute path="/admin" isAuth={this.props.user.isAuth} component={LazyCaptainDashboard}/> :
              <PrivateRoute path="/admin" isAuth={this.props.user.isAuth} component={LazyAdminDashboard}/> 
            }
            <Route path="/login" component={LazyLogin}/>
            <Redirect to="/admin"/>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default hot(module)(connect((state) => ({ user: state.user}))(App));



// WEBPACK FOOTER //
// ./src/App.js